<script>
import statisticClient from "@/api/central/statistics";
import dayjs from "dayjs";

export default {
  props: {
    dateFrom: {
      type: String,
      default: dayjs().format("YYYY-MM-DD")
    },
    dateTo: {
      type: String,
      default: dayjs().format("YYYY-MM-DD")
    },
    events: {
      required: false,
      type: String | Number,
      default: ""
    }
  },

  data() {
    return {
      keyFigures: {}
    };
  },

  methods: {
    loadKeyFigures() {
      statisticClient
        .keyFigures(this.dateFrom, this.dateTo, this.events)
        .then(({ data }) => (this.keyFigures = data.data));
    }
  },

  watch: {
    dateFrom: {
      handler: function() {
        this.loadKeyFigures();
      },
      immediate: true
    },
    dateTo: {
      handler: function() {
        this.loadKeyFigures();
      }
    }
  },

  render: function(createElement) {
    return createElement("div", [
      this.$scopedSlots.default({
        keyFigures: this.keyFigures
      })
    ]);
  }
};
</script>
